<h1 mat-dialog-title>Elenco attivazioni {{ title }}</h1>

<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

  <table class="table table-borderless table-striped">
    <thead>
      <th>Relazione</th>
      <th>Documenti</th>
      <th>Azioni</th>
    </thead>
    <tbody>
      <tr *ngFor="let item of activationItems; let i = index">
        <td><div [innerHtml]="item.fields"></div></td>
        <td><div [innerHtml]="item.docs"></div></td>
        <td>
          <div class="row">
            <div class="col-6">
              <mat-icon fontSet="fal" fontIcon="fa-pencil" class="icon-action"
                matTooltip="Modifica attivazione"
                (click)="onEdit(item.id)">
              </mat-icon>
            </div>
            <div class="col-6">
              <mat-icon fontSet="fal" fontIcon="fa-trash" class="icon-action" matTooltip="Elimina attivazione"
                (click)="onDelete(item.id)">
              </mat-icon>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>

<div mat-dialog-actions class="mt-5">
  <div class="row w-100">
    <div class="col-6 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default color="warn">
        {{ 'common.cta.close' | translate }}
      </a>
    </div> <!-- /.col -->
    <div class="col-6 text-right">
      <div class="col-6 text-right">
        <a mat-button (click)="onNew()" mat-raised-button mat-default color="accent">
          Aggiungi attivazione
        </a>
      </div>
      <!--
      <a mat-button (click)="onFormSubmit()" mat-raised-button mat-default color="warn">
        {{ 'common.cta.save' | translate }}
      </a>
    </div>  /.col -->
  </div> <!-- /.row -->
</div>
